import { FFmpeg } from "@ffmpeg/ffmpeg";
import { toBlobURL } from "@ffmpeg/util";

let ffmpegInstance: FFmpeg | null = null;
let ffmpegLoadPromise: Promise<FFmpeg> | null = null;

export const getInstance = async (): Promise<FFmpeg> => {
  if (ffmpegInstance) return ffmpegInstance;
  if (ffmpegLoadPromise) return await ffmpegLoadPromise;

  ffmpegLoadPromise = (async () => {
    const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/esm";
    const ffmpeg = new FFmpeg();

    // XXX: Explicitly specify custom paths for ffmpeg-core.js and ffmpeg-core.wasm
    // The default core files do not function correctly in some browser environments,
    // so we load them manually from a known reliable CDN source (unpkg).

    await ffmpeg.load({
      coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, "text/javascript"),
      wasmURL: await toBlobURL(
        `${baseURL}/ffmpeg-core.wasm`,
        "application/wasm",
      ),
    });

    ffmpegInstance = ffmpeg;
    return ffmpeg;
  })();

  return await ffmpegLoadPromise;
};
